import { v4 as uuid } from 'uuid';

export const createInitialPackMappingSetState = () => ({
  id: uuid(),
  name: '',
  mappings: [createInitialPackMappingState()],
});

export const createInitialPackMappingState = () => ({
  id: uuid(),
  skus: [],
  attributeModelUrl: '',
  attributeModel: undefined,
  packCalculatorUrl: '',
  packCalculator: createInitialPackCalculatorState(),
  packCalculatorList: undefined,
  retrievedPackCalculatorListIds: undefined,
  packGroupName: undefined,
});

export const BIGGEST_PACKS = 'biggestPacks';
export const EVEN_PACKS = 'evenPacks';

export const createInitialPackCalculatorState = () => ({
  id: uuid(),
  name: 'new pack',
  inputs: [
    {
      scope: 'productConfig',
      name: 'Width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Height',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'trim width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'trim height',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Cover Trim Width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Cover Trim Height',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'substrate weight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Page Substrate Weight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Cover Substrate Weight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'folded width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'folded height',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'substrate thickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'lamination thickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'weight per piece',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'number of sides',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Number of sides (cover included)',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'FlatCustomWidth',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'FlatCustomHeight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'quantity',
      required: false,
    },
    {
      scope: 'pack',
      name: 'quantity',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Finished Width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Finished Height',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Weight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'CustomWidth',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'CustomHeight',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Spine Size',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Spine Width',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'PageCount',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'PageCount - including cover',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Thickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Page Substrate Thickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Cover Substrate Thickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'CoverThickness',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Label Gapping',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Roll Size',
      required: false,
    },
    {
      scope: 'productConfig',
      name: 'Roll Core Diameter',
      required: false,
    }
  ],
  packableQuantities: '',
  preferredPackQuantity: '',
  maxQuantity: '',
  shreddingStrategy: BIGGEST_PACKS,
  packsPerContainer: '',
  preferredContainerType: 'box',
  weightFormula: '',
  lengthFormula: '',
  widthFormula: '',
  heightFormula: '',
  diameterFormula: '',
  dimensionUnit: 'cm',
  weightUnit: 'g',
});
